var map = {
  "./en.json": [
    "44174"
  ],
  "./de.json": [
    "95894",
    "43963"
  ],
  "./es-ES.json": [
    "39480",
    "26753"
  ],
  "./es.json": [
    "46725",
    "7110"
  ],
  "./fr-FR.json": [
    "19044",
    "15749"
  ],
  "./ja.json": [
    "87980",
    "73053"
  ],
  "./pt-BR.json": [
    "46040",
    "69985"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = function() { return Object.keys(map); };
__rspack_async_context.id = 72096;
module.exports = __rspack_async_context;
